"use client";

import { FileQuestion } from "lucide-react";
import { ErrorPageLayout } from "./components/ErrorPageLayout";

export function NotFoundPage() {
  return (
    <ErrorPageLayout
      code="404"
      title="Page Not Found"
      description="The page you're looking for doesn't exist or has been moved. Check the URL or navigate back to explore our site."
      icon={FileQuestion}
      showGoBack={true}
    />
  );
}

export default NotFoundPage;
